import React from "react"
import { Script } from "gatsby"
import { useStore } from "../../context/auth/auth"
import Cookies from "js-cookie"

// Read `_vwo_consent` from cookies
const getVWOConsentFromCookies = () => {
  if (typeof document === "undefined") return null

  const match = Cookies.get("_vwo_consent")
  if (!match) return null

  const consentValue = match.split("%3A")[0] // Extract before "%3A"
  return parseInt(consentValue, 10) || null
}

const updateVWOConsentState = () => {
  if (typeof window === "undefined") return

  window.VWO = window.VWO || []
  window.VWO.init =
    window.VWO.init ||
    function (state) {
      window.VWO.consentState = state
    }

  const consentState = getVWOConsentFromCookies() ?? 3 // Default to 3 (Denied)

  if (typeof window.VWO.init === "function") {
    window.VWO.init(consentState)
  }
}

const VwoScript = () => {
  if (typeof window === "undefined") return

  updateVWOConsentState()

  // Listen for consent changes in OneTrust (if available)
  if (window.OneTrust) {
    window.OneTrust.OnConsentChanged(() => {
      updateVWOConsentState()
    })
  }

  return (
    <Script
      type="text/javascript"
      id="vwoCode"
      dangerouslySetInnerHTML={{
        __html: `
window._vwo_code || (function() {
var account_id=757115,
version=2.1,
settings_tolerance=2000,
hide_element='body',
hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
/* DO NOT EDIT BELOW THIS LINE */
f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='vwo'+account_id+'settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();
      `,
      }}
    />
  )
}

export const LayoutScriptLoader = siteConfig => {
  const [, dispatch] = useStore()

  let googleOptimizeId = process.env.GOOGLE_OPTIMIZE_ID,
    // Get the Google Optimize container ID from the site config
    optimizeContainer = null,
    currentSiteConfig = siteConfig?.siteConfig,
    configValues = siteConfig?.siteConfigValues

  // GATSBY_ prefix allows you to use env variables browser-side for local testing.
  let gtmContainerId =
    process.env.GTM_CONTAINER_ID || process.env.GATSBY_GTM_CONTAINER_ID

  let disableOneTrust = false
  if (process.env.GATSBY_DISABLE_ONETRUST === "true") {
    disableOneTrust = true
  }

  if (currentSiteConfig) {
    if (process.env.GATSBY_ENV === "development") {
      optimizeContainer = configValues?.developmentOptimizeContainerId
      // Only re-assign variable if config exists
      configValues?.developmentGtmContainerId &&
        (gtmContainerId = configValues.developmentGtmContainerId)
    } else if (process.env.GATSBY_ENV === "production" || process.env.GATSBY_ENV === "staging") {
      optimizeContainer = configValues?.productionOptimizeContainerId
      // Only re-assign variable if config exists
      configValues?.productionGtmContainerId &&
        (gtmContainerId = configValues.productionGtmContainerId)
    } else if (
      process.env.GATSBY_ENV === "preview" ||
      process.env.GATSBY_IS_PREVIEW === "true"
    ) {
      optimizeContainer = configValues.previewOptimizeContainerID
      // Only re-assign variable if config exists
      configValues.previewGtmContainerId &&
        (gtmContainerId = configValues.previewGtmContainerId)
    }
  }
  const munchkins = configValues?.munchkins

  const renderMunchkinInstances = munchkins => {
    if (munchkins && munchkins?.length) {
      let munchkinInstances = munchkins.split(",")
      let markup = []
      munchkinInstances?.forEach(id => {
        markup.push(
          <Script
            type="text/javascript"
            key={id}
            dangerouslySetInnerHTML={{
              __html: `
                // MUNCHKIN SCRIPT
                (function() {
                  var didInit = false
                  function initMunchkin() {
                    if (didInit === false) {
                      didInit = true
                      Munchkin.init("${id.trim()}")
                    }
                  }
                  var s = document.createElement("script")
                  s.type = "text/javascript"
                  s.async = true
                  s.src = "//munchkin.marketo.net/munchkin.js"
                  s.onreadystatechange = function () {
                    if (this.readyState == "complete" || this.readyState == "loaded") {
                      initMunchkin()
                    }
                  }
                  s.onload = initMunchkin
                  document.getElementsByTagName("head")[0].appendChild(s)
                })();
              `,
            }}
          />
        )
      })
      return markup
    }
  }

  const oneTrustId = configValues?.oneTrustId || null
  const hubSpotId = configValues?.hubSpot || null
  const answerDashId = configValues?.answerDashId || null
  const leadFeederId = configValues?.leadFeederId || null
  return (
    <>
      <Script type="application/ld+json">
        {`
          ${JSON.stringify(siteConfig?.structuredData)}
        `}
      </Script>
      {renderMunchkinInstances(munchkins)}
      {hubSpotId && (
        <Script
          type="text/javascript"
          id="hs-script-loader"
          src={`//js.hs-scripts.com/${hubSpotId}.js`}
        />
      )}

      {hubSpotId && (
        <Script
          charSet="utf-8"
          type="text/javascript"
          src="//js.hsforms.net/forms/v2.js?pre=1"
        />
      )}

      <Script
        id="teknklFormsPlus-1.0.5-Util"
        src="https://s3-us-west-2.amazonaws.com/assets.creative-strategies/teknklFormsPlus-1.0.5-Util.js"
        key={`teknklFormsPlus-1.0.5-Util`}
      />

      {googleOptimizeId && (
        <Script
          src={`https://www.googleoptimize.com/optimize.js?id=${googleOptimizeId}`}
          key="google-optimize-script"
        />
      )}
      {optimizeContainer && (
        <Script
          src={`https://www.googleoptimize.com/optimize.js?id=${optimizeContainer}`}
        />
      )}

      {answerDashId && (
        <Script
          dangerouslySetInnerHTML={{
            __htmls: `var AnswerDash;!function(e,t,n,s,a){if(!t.getElementById(s)){var i,r=t.createElement(n),c=t.getElementsByTagName(n)[0];e[a]||(i=e[a]=function(){i.__oninit.push(arguments)},i.__oninit=[]),r.type="text/javascript",r.async=!0,r.src="https://p1.answerdash.com/answerdash.min.js?siteid=${answerDashId}",r.setAttribute("id",s),c.parentNode.insertBefore(r,c)}}(window,document,"script","answerdash-script","AnswerDash");`,
          }}
        />
      )}
      {answerDashId && (
        <Script
          type="text/javascript"
          async
          src={`//p1.answerdash.com/answerdash.min.js?siteid=${answerDashId}`}
        />
      )}
      {answerDashId && (
        <Script
          async=""
          type="text/javascript"
          src="https://p1.answerdash.com/js/dist/answerdash-jquery-2.1.4.min.js"
        />
      )}

      {oneTrustId && !disableOneTrust && (
        <>
          <Script
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            type="text/javascript"
            charset="UTF-8"
            data-domain-script={oneTrustId}
            onLoad={() => {
              dispatch({
                type: "ONE_TRUST_INITIALIZED",
              })
            }}
          />
          <Script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: "function OptanonWrapper() { }",
            }}
          />
        </>
      )}

      {gtmContainerId && (
        <Script
          id="gtm-script"
          key="gtm-script"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${gtmContainerId}');
            `,
          }}
        />
      )}
      <Script
        key="meta-locator-dynamic-loader-script"
        dangerouslySetInnerHTML={{
          __html: `
          var ml___params = {"lang":"${siteConfig?.metaLocatorLanguage?.value}"};
        function showLocator(divId, Itemid) {
          domWrite(
            divId,
            "https://code.metalocator.com/index.php?option=com_locator&view=directory&layout=_javascript&framed=1&format=raw&tmpl=component&no_html=1&Itemid=" +
              Itemid
          )
          return false
        }
        var domWrite = (function () {
          // private
          var c = 0
          function evals(pString) {
            var scripts = [],
            script,
            regexp = new RegExp("<Script[^>]*>([sS]*?)", "gi")
            while ((script = regexp.exec(pString))) {scripts.push(script[1])}
            scripts = scripts.join("\\n")
            if (scripts) eval(scripts)
          }
          return function (pDiv, pSrc) {
            // public
            var e = typeof pDiv == "string" ? document.getElementById(pDiv) : pDiv, // the div element
            s = document.createElement("script"),
            dw = document.write, // save document.write()
            buf = "", // output string buffer
            oldbuf = "", // output string buffer
            t = "", // timeout
            ms = 100 // milliseconds
            function exec() {
              if (buf !== oldbuf) {
                oldbuf = buf
                t = window.setTimeout(exec, ms)
              } else {
                e.innerHTML = buf
                evals(buf)
                if (c-- === 0) {
                  document.write = dw
                }
              }
            }
            document.write = function (pString) {
              window.clearTimeout(t)
              oldbuf = buf
              buf += pString
              t = window.setTimeout(exec, ms)
            }
            c++
            s.setAttribute("language", "javascript")
            s.setAttribute("type", "text/javascript")
            s.setAttribute("src", pSrc)
            document.getElementsByTagName("head")[0].appendChild(s)
          }
        })()
        `,
        }}
      />
      <VwoScript />
      <Script
        type="text/javascript"
        id="gainsight-script"
        dangerouslySetInnerHTML={{
          __html: `
            const appMode = "${process.env.GATSBY_ECOM_ENV}";
            let aptrinsicId;
            switch (appMode) {
                case 'prod':
                    aptrinsicId = 'AP-UNM677VB2XAD-2';
                    break;
                case 'dev':
                case 'local':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
                    break;
                case 'qa':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-3';
                    break;
                case 'sit':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-4';
                    break;
                default:
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
            }
            (function (n, t, a, e, co) {
                var i = 'aptrinsic';
                (n[i] =
                    n[i] ||
                    function () {
                        (n[i].q = n[i].q || []).push(arguments);
                    }),
                    (n[i].p = e);
                n[i].c = co;
                var r = t.createElement('script');
                (r.async = !0), (r.src = a + '?a=' + e);
                var c = t.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(r, c);
            })(
                window,
                document,
                'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
                aptrinsicId
            );
            `,
        }}
      />
      {leadFeederId && (
        <Script
          id="leadfeeder-script"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
              (function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));}; (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1; fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })('${leadFeederId}');
            `,
          }}
        />
      )}
    </>
  )
}
